/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
	'game',[
		'absolute',
		'state-machine',
		'gameui',
		'util/SettingsManager',
		'util/ThemeManager',
		'MenuUI/MenuBar',
		'Solitaire/SolitaireGameMode',
		'Solitaire/Solitaire',
		'Solitaire/DailyChallenges/KlondikeChallenge',
		'Solitaire/DailyChallenges/SpiderChallenge',
		'MenuUI/GameScreenUI',
		'Arkadium/GameEngine/Core/EngineManagers',
		'Managers/KeyboardManager',
		'Managers/TelemetryManager'
	],
	function (
		Absolute,
		StateMachine,
		GameUI,
		SettingsManager,
		ThemeManager,
		MenuBar,
		SolitaireGameMode,
		SolitaireGame,
		KlondikeChallenge,
		SpiderChallenge,
		GameScreenUI,
		EngineManagers,
		KeyboardManager,
		TelemetryManager
	) {
		var GenericGame = function (name, config) {
			this._initGenericGame(name, config);
		};

		GenericGame.prototype = Object.create(Absolute.Game.prototype);

		GenericGame.prototype._initGenericGame = function (name, config) {

			this.checkForSeparateGame(config);

			Absolute.Game.call(this,
				name,
				{
					version: 1,
					musicEnabled: true,
					sfxEnabled: true,
					lastLevel: 0,
					completedLevels: [],
					config: config.config
				});

			this.lastState = 'loading';

			this.firstRun = true;

			this.currentLevel = 0;

			this.initStateMachine();

			this.ui = new GameUI(this, config);


			KeyboardManager.initialize(this.ui);

		};

		GenericGame.prototype.checkForSeparateGame = function (config) {
			var query = {};
			var queryString = window.location.search;
			var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
			for (var i = 0; i < pairs.length; i++) {
				var pair = pairs[i].split('=');
				query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
			}
			if (query.singleGame && (SolitaireGameMode[query.singleGame] >= 0)) {
				config.config.singleGame = {
					enabled: true,
					mode: query.singleGame
				};
			} else {
				config.config.singleGame = {
					enabled: false
				};
			}
		};
		GenericGame.prototype.makeGame = function () {
			this.solitaire = new SolitaireGame(this.ui, this);
			SolitaireGame.Current = this.solitaire;
		};

		GenericGame.prototype.startGame = function (mode, challenge, newDeal, resetScoring, statLossRedeal, showAd) {

			if (this.fsm.current == "playing") {
				// if we're currently in another game, stop it before starting a new one
				this.solitaire.StopGame(false);
			}

			this.makeGame();
			this.mode = mode;
			this.newDeal = !!newDeal;
			this.resetScoring = !!resetScoring;
			this.statLossRedeal = !!statLossRedeal;

			if (challenge) {
                ThemeManager.CurrentTheme = challenge.Theme;
                if (Absolute.Platform.isMobile())
                    ThemeManager.CurrentTheme = "mobile";

				this.solitaire.CurrentChallenge = challenge;
				this.startChallengeLevel();
			} else {
                ThemeManager.CurrentTheme = SettingsManager.getSetting('theme', 'selected');

                if (Absolute.Platform.isMobile())
                    ThemeManager.CurrentTheme = "mobile";

				this.startLevel(showAd);
			}

		};

		GenericGame.prototype.makeCannedChallenge = function () {
			var challenge,
				parameters = {
					"CARDTOPLAY": "5S",
					"SCORING": "STANDARD",
					"DRAW": "3"
				};

			challenge = new KlondikeChallenge(KlondikeChallenge.GoalType.PlayCard, parameters);
			challenge.ChallengeName = "5S to Foundation";
			//Klondike.ChallengeA.GoalDescription = "Play the 5 of spades to a foundation";

			challenge.DealScript = "BEGIN MOVE Root Tableau0 1 MOVE Root FaceDown1 1 MOVE Root Tableau1 1 MOVE Root FaceDown2 2 MOVE Root Tableau2 1 MOVE Root FaceDown3 3 MOVE Root Tableau3 1 " +
				"MOVE Root FaceDown4 4 MOVE Root Tableau4 1 MOVE Root FaceDown5 5 MOVE Root Tableau5 1 MOVE Root FaceDown6 6 MOVE Root Tableau6 1 MOVE Root Stock 24 END";

			challenge.DeckSeeds.push("47706333570411672787770178916737634662827145888245233918205149382562");

			return challenge;
		};

		GenericGame.prototype.handleVisibilityChange = function (hidden) {
			Absolute.Game.prototype.handleVisibilityChange.call(this, hidden);


			if (hidden) {
				//this.savedGameState = this.fsm.current;
				Absolute.MusicManager.stopMusic();
				if (Absolute.AudioManager.isSfxEnabled()) {
					Absolute.AudioManager.muteAll();
				}

			} else if (this.fsm.current !== 'loading') {

				if (Absolute.AudioManager.isSfxEnabled()) {
					Absolute.AudioManager.unmuteAllSfx();
				}

				if (this.ui && this.ui.currentScreen && typeof this.ui.currentScreen.handleVisibilityChange == 'function') {
					this.ui.currentScreen.handleVisibilityChange(hidden);
				}
			}

		};


		GenericGame.prototype.load = function (assets, onLoadProgress, onLoadComplete) {
			this.ui.load(assets, onLoadProgress, onLoadComplete);
		};


		GenericGame.prototype.initStateMachine = function () {
			this.fsm = StateMachine.create({

				events: [
					{ name: 'init', from: 'none', to: 'loading' },
					{ name: 'start', from: 'loading', to: 'mainmenu' },
					{ name: 'startlevel', from: '', to: 'playing' },
					{ name: 'navmain', from: '', to: 'mainmenu' },
					{ name: 'navdaily', from: '', to: 'dailymenu' },
					{ name: 'navawards', from: '', to: 'awards' },
					{ name: 'navawardsachievements', from: '', to: 'awardsachievements' },
					{ name: 'navstarclub', from: '', to: 'starclubmenu' },
					{ name: 'navsccollection', from: '', to: 'sccollectionmenu' },
					{ name: 'navscchallenge', from: '', to: 'scchallengemenu' },
					{ name: 'startchallengelevel', from: '', to: 'playing' },
					{ name: 'navstatsdetail', from: '', to: 'statsdetailmenu' },
					{ name: 'navhtp', from: '', to: 'htp' },
					{ name: 'navthemes', from: '', to: 'themes' }
				],
				callbacks: {
					onnavmain: this.onNavMain.bind(this),
					onstart: this.onStart.bind(this),
					onstartlevel: function (name, from, to, showAd) {
						this.onStartLevel(showAd);
					}.bind(this),
					onendlevel: this.onEndLevel.bind(this),
					onnavdaily: this.onNavDaily.bind(this),
					onnavawards: this.onNavAwards.bind(this),
					onnavawardsachievements: this.onNavAwardsAchievements.bind(this),
					onnavstarclub: this.onNavStarClub.bind(this),
					onnavsccollection: this.onNavSCCollection.bind(this),
					onnavscchallenge: this.onNavSCChallenge.bind(this),
					onstartchallengelevel: this.onStartLevel.bind(this),
					onnavstatsdetail: this.onNavStatsDetail.bind(this),
					onnavhtp: this.onNavHtp.bind(this),
					onnavthemes: this.onNavThemes.bind(this),
					onleaveplaying: this.onLeavePlaying.bind(this),
					onchangestate: function (event, from, to) {
						this.lastState = from;
						Absolute.Debug.log("CHANGED STATE: " + from + " to " + to);
					}.bind(this)
				}
			});

			this.fsm.init();
		};

		GenericGame.prototype.onStart = function () {
			if (!this.menuBar) {
				this.menuBar = new MenuBar({}, this.ui, this);
			}
			if (!this.gameScreenUI) {
				this.gameScreenUI = new GameScreenUI({}, this.ui, this);
			}

			const searchParams = new URLSearchParams(window.location.search);
			var mode = searchParams.get('game');
			
			if (this.config.singleGame.enabled) {
				this.startGame(SolitaireGameMode[this.config.singleGame.mode]);
			} else if (SolitaireGameMode[mode] >= 0) {
				this.startGame(SolitaireGameMode[mode]);
			} else {
				this.ui.showMainMenu();
			}
		};

		GenericGame.prototype.onNavMain = function () {
			if (this.config.singleGame.enabled) {
				this.startGame(SolitaireGameMode[this.config.singleGame.mode]);
			} else {
				this.ui.showMainMenu();
			}
		};

		GenericGame.prototype.onStartLevel = function (showAd) {
			this.ui.showGameScreen(showAd);
		};

		GenericGame.prototype.onNavDaily = function () {
			this.ui.showDailyChallengeMenu();
		};

		GenericGame.prototype.onNavAwards = function (s, s1, a, year) {
			this.ui.showAwardsMenu(year);
		};

		GenericGame.prototype.onNavAwardsAchievements = function () {
			this.ui.showAwardsAchievementsMenu();
		};

		GenericGame.prototype.onNavStarClub = function () {
			this.ui.showStarClubMenu();
		};

		GenericGame.prototype.onNavSCCollection = function () {
			this.ui.showStarClubCollectionMenu();
		};

		GenericGame.prototype.onNavSCChallenge = function () {
			this.ui.showStarClubChallengeMenu();
		};

		GenericGame.prototype.onEndLevel = function () {
			if (this.solitaire) {
				this.solitaire.CurrentChallenge = null;
			}
			if (this.fsm.current == "dailymenu") {
				this.ui.showDailyChallengeMenu();
			} else if (this.fsm.current == "scchallengemenu") {
				this.ui.showStarClubChallengeMenu();
			} else {
				if (this.config.singleGame.enabled) {
					this.startGame(SolitaireGameMode[this.config.singleGame.mode]);
				} else {
					this.ui.showMainMenu();
				}
			}
		};

		GenericGame.prototype.onNavStatsDetail = function () {
			this.ui.showStatsDetailMenu();
		};

		GenericGame.prototype.onNavHtp = function () {
			this.ui.showHtpScreen(this.htpMode);
		};

		GenericGame.prototype.onNavThemes = function () {
			this.ui.showThemesScreen();
		};

		GenericGame.prototype.start = function () {
			this.fsm.start();
		};

		GenericGame.prototype.startLevel = function (showAd) {
			this.fsm.startlevel(showAd);
		};

		GenericGame.prototype.startChallengeLevel = function () {
			this.fsm.startchallengelevel();
		};

		GenericGame.prototype.endLevel = function () {

			this.fsm.endlevel();
		};

		GenericGame.prototype.onLeavePlaying = function () {
			// force the game to stop when we leave this state
			this.solitaire.StopGame(false);
		};

		GenericGame.prototype.navBack = function () {
			if (this.config.singleGame.enabled) {
				this.startGame(this.mode, null, null, null, null, false);
				return;
			}

			if ((this.fsm.current == "awardsachievements" || this.fsm.current == "awards" || this.fsm.current == "playing" || this.fsm.current == "htp" || (this.fsm.current == "statsdetailmenu" && this.lastState == "playing")) && this.lastState !== 'statsdetailmenu' && this.lastState !== "awards") {

				switch (this.lastState) {
					case "dailymenu":
						this.fsm.navdaily();
						break;
					case "scchallengemenu":
						this.fsm.navscchallenge();
						break;
					case "mainmenu":
						this.fsm.navmain();
						break;
					case "awardsachievements":
						this.fsm.navawardsachievements();
						break;
					case "playing":
						this.startGame(this.mode, this.solitaire.CurrentChallenge, null, null,
							null, false);
						break;
					case "starclubmenu":
						this.fsm.navstarclub();
						break;
					case "sccollectionmenu":
						this.fsm.navsccollection();
						break;
					case "scchallengemenu":
						this.fsm.navscchallenge();
						break;
					case "statsdetailmenu":
						this.navStatsDetail(this.statsDetailModel);
						break;
					case "htp":
						// this might be wrong this should only happen when the user goes from 'playing' to 'htp' then
						// back to 'playing'
						this.fsm.navmain();
				}
			} else {
				switch (this.fsm.current) {

					case "playing":
						this.fsm.navmain();
						break;
					case "dailymenu":
						this.fsm.navmain();
						break;
					case "awardsachievements":
						this.fsm.navmain();
						break;
					case "scchallengemenu":
						this.fsm.navsccollection();
						break;
					case "sccollectionmenu":
						this.fsm.navstarclub();
						break;
					case "starclubmenu":
						this.fsm.navmain();
						break;
					case "statsdetailmenu":
						this.fsm.navmain();
						break;
				}
			}

		};

		GenericGame.prototype.navDaily = function () {
			this.fsm.navdaily();
		};

		GenericGame.prototype.navStarClub = function () {
			this.fsm.navstarclub();
		};

		GenericGame.prototype.navStarClubCollection = function (collection) {
			this.ui.setStarClubCollection(collection);
			this.fsm.navsccollection();
		};

		GenericGame.prototype.navStarClubChallenge = function (challengePack) {
			this.ui.setStarClubChallengePack(challengePack);
			this.fsm.navscchallenge();
		};

		GenericGame.prototype.navStatsDetail = function (statsDetailModel) {
			this.statsDetailModel = statsDetailModel;
			this.ui.setStatsDetailModel(statsDetailModel);
			this.fsm.navstatsdetail();
		};

		GenericGame.prototype.navAwards = function (year) {
			this.fsm.navawards(year);
		};

		GenericGame.prototype.navAwardsAchievements = function () {
			this.fsm.navawardsachievements();
		};

		GenericGame.prototype.navHtp = function (htpMode) {
			this.htpMode = htpMode;
			this.fsm.navhtp();
		};

		GenericGame.prototype.navThemes = function () {
			this.fsm.navthemes();
		};

		GenericGame.prototype.navMain = function () {
			this.fsm.navmain();
		};

		GenericGame.prototype.updateSetting = function (setting, value) {
			switch (setting) {
				case 'soundFx':
					EngineManagers.Sounds.UpdateSoundState(value, -1);
					break;
				case 'music':
					EngineManagers.Sounds.UpdateSoundState(-1, value);
					break;
				case 'hints':
					break;
				case 'showAlerts':
					break;
				case 'gameEndAnimation':
					break;
				case 'showUndoBoardAlert':
					break;
			}
		};

		GenericGame.prototype.isBrowserSupported = function () {
			// todo: add any other supported browsers here
			return Absolute.Platform._isIE() ||
				Absolute.Platform._isChromeGeneric() ||
				Absolute.Platform._isFirefox() ||
				Absolute.Platform._isSafari();
		};

		return GenericGame;

	});

